import TodoContainer from "../../../Components/Application/Todo/Todo"

const Todo = () => {
  return (
    <div className='page-body'>
      <TodoContainer />
    </div>
  )
}

export default Todo